/**
 * Debug logger utility - only logs in development environment
 * Usage: import { debug } from '@/utils/logger';
 *        debug('[Component]', 'message', data);
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logs debug messages only in development environment
 * @param {...any} args - Arguments to pass to console.log
 */
export const debug = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Logs debug messages with a specific prefix/tag
 * @param {string} tag - The prefix tag (e.g., '[AuthProvider]')
 * @returns {function} - A debug function that prepends the tag
 */
export const createDebugger = (tag) => {
  return (...args) => {
    if (isDevelopment) {
      console.log(tag, ...args);
    }
  };
};

const logger = { debug, createDebugger };
export default logger;
